<div style="margin: 10px 10px 10px 10px;">

	<port-poe-status-editor [ifTableHeightVh]="100" [ifTableHeightPx]="-510" [ifTableMinHeight]="150">
	</port-poe-status-editor>

</div>
